export const SNAP_SIZE = 25;

export function generateSeatId(tableId, part) {
    return tableId + '_' + part;
}
